import { SVGInterface } from "../../interface";

const LineUp = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M13 15.414C13.1875 15.6015 13.4418 15.7069 13.707 15.707H14.293C14.5582 15.7069 14.8125 15.6015 15 15.414L19.707 10.707L22 13V7H16L18.293 9.293L14 13.586L11 10.586C10.8125 10.3985 10.5582 10.2931 10.293 10.293H9.70697C9.44177 10.2931 9.18746 10.3985 8.99997 10.586L2.29297 17.293L3.70697 18.707L9.99997 12.414L13 15.414Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default LineUp;
